var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "card h-auto", staticStyle: { width: "100%" } }, [
      _c("div", { staticClass: "d-flex justify-content-start border-bottom" }, [
        _c(
          "div",
          { staticClass: "flex-grow-1" },
          [
            _c("newsfeed-owner-info", {
              attrs: {
                user_data: _vm.data.module.owner,
                profile_data: null,
                supplier_data: _vm.data.supplier,
                shared: false,
                type: _vm.data.type,
                time: null,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "btn-group mt-1",
            staticStyle: { right: "10px", position: "absolute" },
          },
          [
            _c("span", {
              staticClass: "font-small-2 text-muted ",
              staticStyle: { "margin-top": "3px" },
              attrs: { title: this.publish_at_full },
              domProps: { textContent: _vm._s(this.publish_at) },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "dropdown" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dropdown-menu",
                  attrs: { "aria-labelledby": "dropdownMenuButton200" },
                },
                [
                  _vm.canUpdate
                    ? _c("span", [
                        _c(
                          "button",
                          {
                            staticClass: "dropdown-item",
                            on: {
                              click: function ($event) {
                                _vm.editing = true
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "feather icon-settings" }),
                            _vm._v(
                              _vm._s(_vm.__("globals.edit_post")) +
                                "\n                            "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.canUpdate
                    ? _c("span", [
                        _c(
                          "button",
                          {
                            staticClass: "dropdown-item danger",
                            on: { click: _vm.destroy },
                          },
                          [
                            _c("i", { staticClass: "feather icon-trash-2" }),
                            _vm._v(
                              _vm._s(_vm.__("globals.delete_post")) +
                                "\n                            "
                            ),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.user_id !== _vm.data.module.user_id
                    ? _c(
                        "button",
                        {
                          staticClass: "dropdown-item danger",
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.report.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "feather icon-alert-triangle",
                          }),
                          _vm._v(
                            _vm._s(_vm.__("globals.report_post")) +
                              "\n                        "
                          ),
                        ]
                      )
                    : _vm._e(),
                ]
              ),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex ml-1 mr-1 mt-0 mb-0" }, [
        _vm.editing
          ? _c("div", { staticClass: "form-group w-100" }, [
              _c(
                "div",
                { staticClass: "card mb-1 mt-1" },
                [
                  _c("editor", {
                    attrs: {
                      "api-key": "no-api-key",
                      init: {
                        skin: "trybz-member",
                        skin_url: "/plugins/tiny-mce-skin/ui/trybz-member",
                        content_css:
                          "/plugins/tiny-mce-skin/content/trybz-member/content.min.css",
                        external_plugins: {
                          customtags:
                            "/plugins/tiny-mce-plugins/customtags/plugin.min.js",
                          loadingbar:
                            "/plugins/tiny-mce-plugins/loadingbar/plugin.min.js",
                        },
                        valid_elements:
                          "p,br,b,i,b/strong,i/em,a[href|target=_blank],li[a|b|i|u|ol|ul],ol[li],ul[li]",
                        plugins:
                          "link quickbars autolink lists customtags loadingbar",
                        link_context_toolbar: true,
                        quickbars_selection_toolbar: "bold italic link bullist",
                        quickbars_image_toolbar: false,
                        quickbars_insert_toolbar: false,
                        link_assume_external_targets: "https",
                        link_target_list: false,
                        link_title: false,
                        toolbar: false,
                        branding: false,
                        elementpath: false,
                        menubar: false,
                        file_picker_types: "",
                        height: 100,
                        content_style:
                          "body { font-family: Montserrat, Helvetica, Arial, serif; font-size: 0.86rem; font-weight: 400; line-height: 1.45; color: #1d2124; }",
                        relative_urls: false,
                        remove_script_host: false,
                      },
                    },
                    model: {
                      value: _vm.post_text,
                      callback: function ($$v) {
                        _vm.post_text = $$v
                      },
                      expression: "post_text",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.external_video_link !== null
                ? _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "external_video_link" } }, [
                      _vm._v(
                        _vm._s(_vm.__("video.field.text.external_url")) + ":"
                      ),
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.external_video_link,
                          expression: "external_video_link",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        name: "external_video_link",
                        id: "external_video_link",
                      },
                      domProps: { value: _vm.external_video_link },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.external_video_link = $event.target.value
                        },
                      },
                    }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group", attrs: { id: "date_time" } },
                [
                  _c(
                    "label",
                    { staticClass: "required", attrs: { for: "published_at" } },
                    [_vm._v(_vm._s(_vm.__("post.post_published_on")) + ":")]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.date_time,
                        expression: "date_time",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "datetime-local",
                      name: "published_at",
                      id: "published_at",
                    },
                    domProps: { value: _vm.date_time },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.date_time = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "help-block",
                    attrs: { role: "alert" },
                  }),
                  _c("strong", [_vm._v("(" + _vm._s(_vm.siteTimezone) + ")")]),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-primary",
                  on: {
                    click: function ($event) {
                      return _vm.update()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.__("globals.update")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-link",
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.__("globals.cancel")))]
              ),
            ])
          : _vm.post_text !== null
          ? _c("div", { staticClass: "d-flex pt-1 pb-1" }, [
              _c("div", {
                directives: [{ name: "linkified", rawName: "v-linkified" }],
                staticClass: "breakAll",
                domProps: {
                  innerHTML: _vm._s(
                    this.$options.filters.nl2br(_vm.post_text, true)
                  ),
                },
              }),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.data.module.video_link !== null
        ? _c(
            "div",
            { staticClass: "mb-05" },
            [_c("video-player", { attrs: { options: _vm.videoOptions } })],
            1
          )
        : _vm.external_video_link !== null &&
          _vm.external_video_link !== "" &&
          !_vm.editing
        ? _c("div", { staticClass: "video_container mb-05" }, [
            _c("iframe", {
              staticClass: "responsive-iframe",
              staticStyle: { "background-color": "#000" },
              attrs: {
                webkitallowfullscreen: "",
                mozallowfullscreen: "",
                allowfullscreen: "",
                src: _vm.external_video_link,
              },
            }),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.data.module.post_image.length > 1
        ? _c("div", { staticClass: "gallery-row mb-05" }, [
            _c(
              "div",
              { staticClass: "gallery-container" },
              [_c("lightbox", { attrs: { items: _vm.images } })],
              1
            ),
          ])
        : _vm.data.module.post_image.length === 1
        ? _c("div", { staticClass: "mb-05" }, [
            _c("div", { staticClass: "card-img-top img-fluid" }, [
              _c("img", {
                staticClass: " img-fluid",
                attrs: { src: _vm.data.module.post_image[0].url },
              }),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.editing && _vm.data.module.post_file !== null
        ? _c(
            "div",
            { staticClass: "m-1" },
            _vm._l(_vm.data.module.post_file, function (file, index) {
              return _c(
                "a",
                {
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.downloadFile(file.id, index)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "card bg-outline-light text-center m-0" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex align-items-center pt-05 pb-05 pl-1 pr-05",
                        },
                        [
                          _c("strong", { staticClass: "text-center m-auto" }, [
                            _c("i", { staticClass: "feather icon-download" }),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.__("post.form.buttons.download_file")
                                ) +
                                " ..." +
                                _vm._s(file.file_name.slice(-20))
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.editing
        ? _c("div", [
            _vm.data.module.post_file !== null
              ? _c(
                  "div",
                  { staticClass: "m-1" },
                  _vm._l(_vm.data.module.post_file, function (file, index) {
                    return _c("div", { staticClass: "d-flex" }, [
                      _c(
                        "a",
                        {
                          staticClass: "flex-grow-1 pr-1",
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.downloadFile(file.id, index)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "card bg-outline-light text-center m-0",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-items-center pt-05 pb-05 pl-1 pr-05 ",
                                },
                                [
                                  _c(
                                    "strong",
                                    { staticClass: "text-center m-auto" },
                                    [
                                      _c("i", {
                                        staticClass: "feather icon-download",
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.__(
                                              "post.form.buttons.download_file"
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "ml-auto",
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.deleteAttachment(file.id, index)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "btn btn-danger text-center" },
                            [
                              _vm.canUpdate
                                ? _c("span", [
                                    _c(
                                      "strong",
                                      { staticClass: "w-100 text-center" },
                                      [
                                        _c("i", {
                                          staticClass: "feather icon-trash-2",
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.__("globals.delete")) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ]
                      ),
                    ])
                  }),
                  0
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.data.group !== null
        ? _c("div", { staticClass: "mx-1 mt-1 mb-05 border-top" }, [
            _c(
              "a",
              { attrs: { href: "/member/group/" + _vm.data.group.slug } },
              [
                _c("div", { staticClass: "card text-white" }, [
                  _c("img", {
                    staticClass: "card-img img-fluid",
                    staticStyle: { height: "3rem" },
                    attrs: {
                      src:
                        _vm.data.group.group_cover == null
                          ? "/images/cover.jpg"
                          : _vm.data.group.group_cover.url,
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "card-img-overlay overflow-hidden overlay-dark d-flex align-items-center pt-05 pb-05 pl-1 pr-05",
                    },
                    [
                      _c(
                        "p",
                        {
                          staticClass: "text-white mb-0",
                          staticStyle: { "line-height": "1rem" },
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.__("globals.posted_in")) + ": "),
                          ]),
                          _vm._v(" " + _vm._s(_vm.data.group.title)),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        { staticClass: "btn-sm btn-outline-white ml-auto" },
                        [
                          _vm._v(_vm._s(_vm.__("globals.view_group")) + " "),
                          _c("i", {
                            staticClass: "feather icon-chevron-right",
                          }),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ])
        : _vm.data.supplier !== null
        ? _c("div", { staticClass: "mx-1 mt-1 mb-05 border-top" }, [
            _c(
              "a",
              { attrs: { href: "/member/supplier/" + _vm.data.supplier.slug } },
              [
                _c("div", { staticClass: "card text-white" }, [
                  _c("img", {
                    staticClass: "card-img img-fluid",
                    staticStyle: { height: "3rem" },
                    attrs: {
                      src:
                        _vm.data.supplier.supplier_cover_image == null
                          ? "/images/cover.jpg"
                          : _vm.data.supplier.supplier_cover_image.url,
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "card-img-overlay overflow-hidden overlay-dark d-flex align-items-center pt-05 pb-05 pl-1 pr-05",
                    },
                    [
                      _c(
                        "p",
                        {
                          staticClass: "text-white mb-0",
                          staticStyle: { "line-height": "1rem" },
                        },
                        [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.__("globals.posted_to")) + " "),
                          ]),
                          _vm._v(" " + _vm._s(_vm.data.supplier.title) + " "),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        { staticClass: "btn-sm btn-outline-white ml-auto" },
                        [
                          _vm._v(_vm._s(_vm.__("globals.view_page")) + " "),
                          _c("i", {
                            staticClass: "feather icon-chevron-right",
                          }),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn-sm btn-outline-light dropdown-toggle ",
        staticStyle: { border: "none" },
        attrs: {
          type: "button",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false",
        },
      },
      [_c("i", { staticClass: "fa fa-chevron-circle-down mr-0" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }